/**
 * Known raw GraphQL error messages returned outside the typed response payload.
 * Single source of truth.
 */
export const GraphQlErrorMessage = {
    PaymentGatewayUnavailable: 'The payment gateway is unavailable.',
    AuthorizationCodeDoesNotExist: 'The authorization code does not exist.',
    Unauthenticated: 'Unauthenticated.',
};
